import React, { ReactNode } from 'react';
import { ApplicationStep } from '../gogurt/routes/RouteItem.types';

export type RouteLike = RouteItem | RouteMulti | ApplicationStep;

export interface RouteItem {
  path: string;
  title: string;
  icon?: ReactNode;
  id?: string;
  subSections?: RouteItem[];
  component: React.ComponentType<any>;
  hideFromProgressUi?: boolean;
}

export interface RouteMulti {
  paths?: string[];
  names?: string[];
  icons?: ReactNode[];
  component: React.ComponentType<any>;
}

export function isRouteMulti(route: RouteLike): route is RouteMulti {
  return Array.isArray((route as RouteMulti).paths);
}

export function isRoutePath(
  route: RouteLike,
  path: string,
): route is RouteItem | RouteMulti {
  return (
    (route as RouteItem).path === path ||
    (route as RouteMulti).paths?.includes(path) ||
    false
  );
}

function isApplicationStep(route: RouteLike): route is ApplicationStep {
  return (route as ApplicationStep).subSections != null;
}

export function getStepFromPath(
  pathname: string,
  routes: Record<string, RouteLike>,
) {
  let res: RouteItem | RouteMulti | null = null;
  for (const stepKey in routes) {
    const step = routes[stepKey];
    if (isRoutePath(step, pathname)) {
      res = step;
    }
    if (isApplicationStep(step)) {
      const subSection = step.subSections?.find(s => isRoutePath(s, pathname));
      if (subSection) {
        res = subSection;
      }
    }
  }
  return res;
}
